import React from "react";
import styles from "./meetings.module.scss";
import TranscriptPage from "./transcriptModal";
import { IconButton  } from "@mui/material";
import Images from "assets/Images";


const MeetingMinutes = ({technology,handleClose, meetingsData}) => {
   
  return (
   <>
         <div className={styles.headerContainer}>
                <h3>Meeting Minutes</h3>
                <IconButton
                  className={styles.closeIcon}
                  aria-label="close"
                  onClick={handleClose}
                >
                  <img src={Images.CLOSE} alt="Close" width="12" />
                </IconButton>
              </div>
              <div className={styles.meetingMinutes}>
        
                <ul>
                    <li><label>Date </label><span className={styles.hide}>: &nbsp;</span>{meetingsData.date}</li>
                    <li><label>Interview Name </label><span className={styles.hide}>: &nbsp;</span>{meetingsData.interview_name}</li>
                    <li><label>Technology  </label><span className={styles.hide}>:&nbsp;</span>{technology.name}</li>
                    <li><label>Candidate</label> <span className={styles.hide}>: &nbsp;</span>{meetingsData.candidate}</li>
                    <li><label>Interviewer</label> <span className={styles.hide}>:&nbsp;</span>{meetingsData.interviewer}</li>
                </ul> 
                 <TranscriptPage transcript={meetingsData.transcript} interviewer={meetingsData.interviewer} candidate={meetingsData.candidate} />
                <div className={styles.btnContainer}>
                    <button>Download</button>
                </div>
            </div>
       </>   
  );
};

export default MeetingMinutes;
